import { Box, Flex, Text, Heading, Card, Grid, SegmentedControl } from '@radix-ui/themes';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { periodService } from '../../../services/teacher/periodService';
import PeriodOverview from './PeriodOverview';
import CoursePerformance from './CoursePerformance';
import StudentPerformance from './StudentPerformance';
import OverallActivePerformance from './graphs/OverallActivePerformance';
import CircleProgress from '../../shared/CircleProgress';
import LoadingIndicator from '../../shared/LoadingIndicator';
import { reportService } from '../../../services/teacher/reportService';
import StudentReport from './StudentReport';
import CourseReport from './CourseReport';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';

const TeacherReports = () => {
    const [periodReport, setPeriodReport] = useState(null);
    const [selectedReport, setSelectedReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [reportView, setReportView] = useState({period:null, type:'courses', id:null});

    const periods = useSelector((state) => state.teacherAccount);
    const dispatch = useDispatch();

    const getData = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await periodService.getPeriodReports();
            console.log('period report>>>>>', data);
            if (data.error) {
                setError(data.error);
            } else {
                setPeriodReport(data);
                const firstPeriodWithStats = data.periods.find(period => period.teaching_plan_stats.length > 0);
                if (firstPeriodWithStats) {
                    setReportView({ period: firstPeriodWithStats.id, type: 'courses', id:firstPeriodWithStats.teaching_plan_stats[0].id });
                }
            }
        } catch (error) {
            setError(error);
            console.error('Error fetching period report:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        console.log('selectedReport>>>>>', selectedReport);
    }, [selectedReport]);

    const getStudentReport = async (studentId) => {
        const data = await reportService.getStudentReport(studentId);
        console.log('student report>>>>>', data);
        setSelectedReport(data);
    };

    const getCourseReport = async (courseId) => {
        const data = await reportService.getCourseReport(courseId);
        setSelectedReport(data);
    };

    const handlePeriodSelect = (period_id) => {
        console.log('period_id', period_id);
        setReportView({period:period_id, type:'courses', id:periodReport.periods.find(period => period.id === period_id).teaching_plan_stats[0].id});
    }

    if (loading) return <LoadingIndicator />;
    if (error) return (<Card className='h-full'>
        <Flex justify="between" className='items items-center gap-2'>
            <ExclamationTriangleIcon />
            <Text color="red">{error ?? error?.message}</Text>
        </Flex>
    </Card>);

    if (Object.keys(periodReport).length === 0) return (
        <Box width="100%">
            <Card>
                <Flex justify="between">
                    <ExclamationTriangleIcon />
                    <Text>No data available</Text>
                </Flex>
            </Card>
        </Box>
    );

    return (
        <Box width="100%">
            <Flex direction="column" gap="4">
                <Flex direction="column" gap="4" style={{ flex: 1 }}>
                    <PeriodOverview
                        periods={periodReport.periods}
                        onSelect={handlePeriodSelect}
                    />
                        <Flex direction="row" gap="4" align="center" justify="between" mt="4">
                            <Text weight="bold" size="2" as="p">Performance</Text>
                            <SegmentedControl.Root defaultValue="courses" value={reportView.type} onValueChange={(value) => setReportView({ ...reportView, type: value })}>
                                <SegmentedControl.Item value="courses">Courses</SegmentedControl.Item>
                                <SegmentedControl.Item value="students">Students</SegmentedControl.Item>
                            </SegmentedControl.Root>
                        </Flex>
                        {reportView.type === 'courses' ? (
                            <CoursePerformance
                                // completionRates={periodReport.completion_rates}
                                // courseStats={periodReport.course_stats}
                                planStats = {periodReport.periods.find(period => period.id === reportView.period).teaching_plan_stats}
                                onSelect={setSelectedReport}
                                selected={selectedReport}
                            />
                        ) : (
                            <StudentPerformance
                                studentSummary={periodReport.students}
                                onSelect={setSelectedReport}
                            />
                            // <Text>Student Performance</Text>
                        )}
                </Flex>
                <Box style={{ flex: 1 }}>
                    <Card>
                        {selectedReport ? (
                            selectedReport.type === 'student' ? (
                                <StudentReport student_id={selectedReport.id} />
                            ) : (
                                <CourseReport course_id={selectedReport.id} />
                            )
                        ) : (
                            <Text>No report selected</Text>
                        )}
                    </Card>
                </Box>
            </Flex>
        </Box>
    );
};

export default TeacherReports;
